// Accepted partner color formats for the concierge theme tokens, normalized to
// the 6-digit hex the token pipeline requires. Computed custom properties come
// back as authored, and 59 of 90 partner themes store palettes as rgb().
const HEX_PATTERN = /^#[0-9a-fA-F]{6}$/;

// Three integer channels only. The closing \)$ right after the third channel
// rejects modern-syntax alpha (rgb(0 0 0 / 50%)); rgba(...) fails ^rgb\(.
const RGB_PATTERN = /^rgb\(\s*(\d{1,3})\s*(?:,\s*|\s+)(\d{1,3})\s*(?:,\s*|\s+)(\d{1,3})\s*\)$/;

export function normalizeThemeColor(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const trimmed = value.trim();

  if (HEX_PATTERN.test(trimmed)) {
    return trimmed.toLowerCase();
  }

  const match = RGB_PATTERN.exec(trimmed);
  if (!match) {
    return null;
  }

  const channels = [match[1], match[2], match[3]].map(Number);
  if (channels.some((channel) => channel > 255)) {
    return null;
  }

  return `#${channels.map((channel) => channel.toString(16).padStart(2, '0')).join('')}`;
}
